import React from 'react';

import {
  ContainerMessage,
  Container,
  Image,
  Message,
  Title,
} from './styles';

export const HighlightReelZeroState = () => (
  <Container>
    <Title>
      Start creating highlight reels
    </Title>
    <Message>
      Collect and share insights with your team
    </Message>
    <Image
      src="../../../.././images/zero-state-highlight-reel.png"
    />
  </Container>
);

export const ClipsZeroState = () => (
  <ContainerMessage>
    Created clips will appear here
  </ContainerMessage>
);

export const NotesZeroState = () => (
  <ContainerMessage>
    Created notes will appear here
  </ContainerMessage>
);

export const TagsZeroState = () => (
  <ContainerMessage>
    Created tags will appear here
  </ContainerMessage>
);

export const NoImageHighlightReelZeroState = () => (
  <ContainerMessage>
    Created highlight reels will appear here
  </ContainerMessage>
);
